import notes_create_form from "./notes_create_form";
export default {
  content: [notes_create_form],
  id: "create_note",
  subtitle: "",
  title: "Add a Note",
};
